var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"bv-example-row",attrs:{"fluid":"true"}},[_c('b-row',[_c('b-col',[_c('br'),_c('b-card',{staticClass:"ml-3"},[_c('h2',[_vm._v("Filesystems")]),_c('filesystems')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }